<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="渠道主体" width="80%" :open="true" :confirmLoading="state.loading" :maskClosable="true"
        @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="平台">
                                <PlatformPick v-model:value="queryParam.platform_id"></PlatformPick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="代理商">
                                <a-input v-model:value="queryParam.nickname" placeholder="代理商姓名或手机号"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="代理身份">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.xftel_type"
                                    placeholder="请选择">
                                    <a-select-option :value="1">个人</a-select-option>
                                    <a-select-option :value="2">公司</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                                <a-divider type="vertical"></a-divider>
                                <a-button type="primary" @click="batchUpdateCustomer">批量更新</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <div>
                <a-row>
                    <a-col :span="3">姓名：{{ props.detailData.customer_name }}</a-col>
                    <a-col :span="3">手机号：{{ props.detailData.customer_tel }}</a-col>
                    <a-col :span="3">代理身份：
                        <a-tag v-if="props.detailData.customer_type == 1" color="blue">个人</a-tag>
                        <a-tag v-else-if="props.detailData.customer_type == 2" color="green">公司</a-tag>
                        <a-tag v-else>{{ props.detailData.customer_type }}</a-tag>
                    </a-col>
                    <a-col :span="3">公司名称：{{ props.detailData.company_name }}</a-col>
                    <a-col :span="3">统一社会信用代码：{{ props.detailData.finance_social_credit_code }}</a-col>
                    <a-col :span="3">其他号码：{{ props.detailData.exigency_tel }}</a-col>
                    <a-col :span="3">微信id：{{ props.detailData.wechat_id }}</a-col>
                    <a-col :span="3">微信昵称：{{ props.detailData.wechat_name }}</a-col>
                </a-row>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id"
                :row-selection="{ selectedRowKeys: state.selectids, type: 'multiple', onChange: onSelectChange }">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'full_name'">
                        <div>{{ record.full_name }}</div>
                        <div>{{ record.platform_name }}</div>
                    </template>
                    <template v-else-if="column.dataIndex === 'xftel_type'">
                        <a-tag v-if="record.xftel_type == 1" color="blue">个人</a-tag>
                        <a-tag v-else-if="record.xftel_type == 2" color="green">公司</a-tag>
                        <a-tag v-else>{{ record.xftel_type }}</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">
                        <a-popconfirm title="确定更新吗?" placement="left" @openChange="(e) => { }"
                            @confirm="sendAudit(record)">
                            <a>更新</a>
                        </a-popconfirm>
                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
import PlatformPick from '@/components/base/PlatformPick.vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '主体名称',
        dataIndex: 'full_name',
        width: 250
    },
    {
        title: '代理商',
        dataIndex: 'seller',
        width: 150
    },
    {
        title: '续费联系人',
        dataIndex: 'finance_contact_name',
        width: 150
    },
    {
        title: '续费联系人电话',
        dataIndex: 'xftel',
        width: 100
    },
    {
        title: '代理身份',
        dataIndex: 'xftel_type',
        width: 100
    },
    {
        title: '公司名称',
        dataIndex: 'finance_company_name',
        width: 100
    },
    {
        title: '统一社会信用代码',
        dataIndex: 'finance_social_credit_code',
        width: 100
    },
    {
        title: '其他号码',
        dataIndex: 'finance_contact_phone',
        width: 100
    },
    {
        title: '微信账号',
        dataIndex: 'finance_contact_wechat_account',
        width: 100
    },
    {
        title: '微信昵称',
        dataIndex: 'finance_contact_wechat_nickname',
        width: 100
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 200
    }
]
interface state {
    loading: boolean
    detailData: object
    selectids: any[] // 选中的id
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    selectids: [],
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/filings/customerlist',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, 'xftel': props.detailData.customer_tel, seller_id: props.detailData.user_id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
const onSelectChange = (selectedRowKeys: any[], val) => {
    state.selectids = selectedRowKeys
}
//批量更新
const batchUpdateCustomer = () => {
    if (state.selectids.length == 0) {
        message.error('请选择要跟新的主体')
        return
    }
    state.loading = true
    let requestParam = {
        url: '/admin/v1/filings/batchUpdateCustomer',
        method: 'post',
        data: {
            filings_id: props.detailData.id,
            customer_ids: state.selectids
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })
}
</script>
<style lang="less" scoped></style>
